<p-table 
    [value]="items()" 
    size="small" 
    [rowHover]="true" 
    [lazy]="true" >
    <ng-template pTemplate="header">
        <tr>
            <th style="min-width: 70px;" pSortableColumn="isinType">Tipo</th>
            <th pSortableColumn="isin">ISIN</th>
            <th style="min-width: 300px;" pSortableColumn="shortDescription">Descrizione</th>
            <th class="text-right" pSortableColumn="priceDate">Data stock</th>
            <th class="text-right" pSortableColumn="priceValue">Prezzo stock</th>
            <th class="text-right">Quote</th>
            <th class="text-right" pSortableColumn="totalActualValue">Controvalore</th>
            <th class="text-right">Capital gain Inv (tax)</th>
            <th class="text-right">Capital gain (tax)</th>
            <th class="text-right" pSortableColumn="tan">TAN</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-investmentRecap>
        <tr class="cursor-pointer" (click)="onSelect.emit(investmentRecap)">
            <td><p-tag [value]="investmentRecap.isinType ?? 'Altro'" severity="secondary" /></td>
            <td><b>{{ investmentRecap.isin }}</b></td>
            <td>{{ investmentRecap.shortDescription }}</td>
            <td class="text-right">{{ investmentRecap.priceDate | date:'dd-MM-yyyy' }}</td>
            <td class="text-right">{{ investmentRecap.priceValue | currency:'EUR' }}</td>
            <td class="text-right">{{ investmentRecap.quantity ?? '0' }}</td>
            <td class="text-right font-bold">{{ investmentRecap.totalActualValue | currency:'EUR' }}</td>
            
            <td class="text-right">
                @if (investmentRecap.quantity > 0) {
                    <span [ngClass]="investmentRecap.taxedCapitalGainInvested >= 0 ? 'text-green-600' : 'text-red-600'">
                        <b>({{ investmentRecap.percInvTax | percent:'1.2-2' }}) {{ investmentRecap.taxedCapitalGainInvested | currency:'EUR' }}</b>
                    </span>
                } @else { - }
            </td>

            <td class="text-right">
                <span [ngClass]="investmentRecap.taxedCapitalGainTotal >= 0 ? 'text-green-600' : 'text-red-600'">
                    <b>({{ investmentRecap.percTotalTax | percent:'1.2-2' }}) {{ investmentRecap.taxedCapitalGainTotal | currency:'EUR' }}</b>
                </span>
            </td>

            <td class="text-right">
                <b [ngClass]="investmentRecap.tan >= 0 ? 'text-green-600' : 'text-red-600'">
                    {{ investmentRecap.tan | percent:'1.2-2' }}
                </b>
            </td>
        </tr>
    </ng-template>

        
</p-table>
